export default "__VITE_ASSET__DAX6sjqV__"